module.exports = __webpack_public_path__ + "static/media/visuel01.dee25cf1.jpg";